import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PageNavigator from '@/components/PageNavigator.vue'

Vue.config.productionTip = false
Vue.component('PageNavigator', PageNavigator)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
